import { type ManualShipmentInput, proto, type ShipmentInput } from '../../prototype/state/store.ts'
import { financeMutation, financeVersion } from '../finance/actions.ts'

const version = (id: string) => financeVersion(proto.state.shipments.find((row) => row.id === id))
export const logisticsActions = {
  createShipment: async (input: ShipmentInput, send: boolean) => {
    const order = proto.state.orders.find((row) => row.deal.id === input.dealId)
    return (
      await financeMutation<{ id: string }>(
        '/logistics',
        { ...input, send, orderVersion: financeVersion(order?.deal) },
        'POST',
      )
    ).id
  },
  createManualShipment: async (input: ManualShipmentInput, send: boolean) =>
    (await financeMutation<{ id: string }>('/logistics/manual', { ...input, send }, 'POST')).id,
  cancelShipment: async (id: string) => {
    await financeMutation(`/logistics/${id}/cancel`, { version: version(id) })
  },
  sendShipment: async (id: string, ttn: string | null) => {
    await financeMutation(`/logistics/${id}/send`, { version: version(id), ttn })
  },
  markDelivered: async (id: string) => {
    await financeMutation(`/logistics/${id}/delivered`, { version: version(id) })
  },
  setShipmentTtn: async (id: string, ttn: string | null) => {
    await financeMutation(`/logistics/${id}/ttn`, { version: version(id), ttn })
  },
  refreshTracking: async (id: string) =>
    (
      await financeMutation<{ message: string }>(`/logistics/${id}/tracking`, {
        version: version(id),
      })
    ).message,
}
